import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    LEADS_FOR_STATUS :"api/CRM/LeadsForRosterPlan",
    ASSIGEND_ROSTER :"api/CRM/AssignedRostersForLead",
    CRM_SETTING :"api/CRM/CRMSetting",
    ASSIGN_LEAD_ROSTER :"api/CRM/AssignLeadRoster",
}

const leadsForRosterPlan = async (data:any):Promise<ApiResponse<any>>=>{
        const res = await privateRequest.post<ApiResponse<any>>(
            ENDPOINTS.LEADS_FOR_STATUS,data
        )
        return res.data;
}
const assignedRostersForLead =async (data:any) :Promise<ApiResponse<any>>=>{
         const res = await privateRequest.get<ApiResponse<any>>(
            `${ENDPOINTS.ASSIGEND_ROSTER}?leadId=${data.leadId}`
        )
         return res.data;
}
const getCrmSetting = async ():Promise<ApiResponse<any>> => {
        const res = await privateRequest.get<ApiResponse<any>>(
            ENDPOINTS.CRM_SETTING
        )
        return res.data;
}

const assignLeadRoster = async (data:any):Promise<ApiResponse<any>>=>{
        const res = await privateRequest.post<ApiResponse<any>>(
            ENDPOINTS.ASSIGN_LEAD_ROSTER,data
        )
        return res.data;
}
const leadsForRosterPlanName = async (data:any):Promise<ApiResponse<any>>=>{
        const res = await privateRequest.post<ApiResponse<any>>(
            ENDPOINTS.LEADS_FOR_STATUS,data
        )
        return res.data;
}

const RosterPlanService ={
    leadsForRosterPlan,
    assignedRostersForLead,
    getCrmSetting,
    assignLeadRoster,
    leadsForRosterPlanName
}


export default RosterPlanService
